import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Chip as MuiChip } from '@mui/material';
import { forwardRef } from 'react';
import { Icon, Typography } from '../../atoms';
import { Tooltip } from '../../legacy/components/Tooltip/Tooltip';
import { useTheme } from '../../theme';
const useColors = (theme) => ({
    default: {
        backgroundColor: theme.palette.primary.lightDove,
        color: theme.palette.primary.darkBlue,
    },
    success: {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.white.main,
    },
    warning: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.white.main,
    },
    error: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.white.main,
    },
});
const TagInner = forwardRef(function TagInner({ label, color = 'default', icon, onClick }, ref) {
    const theme = useTheme();
    const colors = useColors(theme);
    return (_jsx(MuiChip, { icon: icon && _jsx(Icon, { variant: icon, size: "small" }), label: _jsx(Typography, { variant: "caption medium", color: color === 'default' ? 'darkBlue' : 'white', children: label }), sx: {
            backgroundColor: colors[color].backgroundColor,
            color: colors[color].color,
            borderRadius: `${theme.shape.borderRadius}px`,
            padding: theme.spacing(102, 103),
            height: theme.spacing(106),
            '& .MuiChip-label': {
                paddingLeft: icon ? 103 : 0,
                paddingRight: 0,
            },
        }, ref: ref, onClick: onClick }));
});
export const Tag = forwardRef(function Tag({ tooltip, ...props }, ref) {
    return (_jsx(_Fragment, { children: tooltip !== undefined ? (_jsx(Tooltip, { description: tooltip, placement: "bottom", children: _jsx(TagInner, { ...props, ref: ref }) })) : (_jsx(TagInner, { ...props, ref: ref })) }));
});
